export default __webpack_public_path__ + "static/media/PeacockPage1.0f876cfe.txt";